/**
* DevExpress Analytics (widgets\criteria\utils.js)
* Version:  21.2.13
* Build date: Apr 10, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var aggregate_1 = require("./operators/aggregate");
exports.operatorTokens = {
    'Plus': '+',
    'Minus': '-',
    'Equal': '=',
    'NotEqual': '<>',
    'Greater': '>',
    'Less': '<',
    'LessOrEqual': '<=',
    'GreaterOrEqual': '>='
};
function criteriaForEach(operator, callback, path) {
    if (path === void 0) { path = ''; }
    callback(operator, path);
    if (operator instanceof aggregate_1.AggregateOperand) {
        operator.leftPart && criteriaForEach(operator.leftPart, callback, path);
        if (operator.leftPart && operator.leftPart['propertyName']) {
            path = path ? [path, operator.leftPart['propertyName']].join('.') : operator.leftPart['propertyName'];
        }
    }
    operator.children().forEach(function (item) { return criteriaForEach(item, callback, path); });
}
exports.criteriaForEach = criteriaForEach;
